export const PLUGIN = "bulletime-core";
